export default __webpack_public_path__ + "static/travel-costs-infographic-867659f9d1d62ea1119fd451149e4104.jpg";